import React from 'react';
import StoreUtils from "../../../../services/Store/StoreUtils";
import {connect} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {withTranslation} from "react-i18next";
import {getMenus} from "../../../../services/Menu/reducer";
import MenuTab from "./MenuTab";
import ScrollableTabs from "../../../../components/Common/ScrollableTabs";

interface OwnProps {
    menuId?: number;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MenuTabs = ({config, menus, menuId}: Props) => {
    if (!StoreUtils.isMultilevelMenu(config) || menus.length < 2) return <></>;

    const sortedMenus = [...menus].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <div className="container-fluid menu-tabs-container">
            <ScrollableTabs hideScrollbars={false} scrollStep={60}>
                {sortedMenus.map((menu: Record<string, any>) => (
                    <MenuTab key={menu.id} name={menu.name} id={menu.id} active={Number(menuId) === menu.id}/>
                ))}
            </ScrollableTabs>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    menus: getMenus(state.menu),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuTabs));